import { styled } from '@mui/system'

export const Wrapper = styled('div')`
    margin: 10px 0;
    border-radius: 12px;

    form {
        display: flex;
        flex-direction: column;
        gap: 10px;

        div:nth-child(1) {
            max-width: 100%;
        }

        #primary-custom-radio-group,
        #not_an_issue,
        #action {
            color: ${({ theme }) => theme.palette.grey[500]};
            font-weight: 600;
            margin: 8px 0;
        }
    }
`

export const ControlWrapper = styled('div')`
    margin: 0 0 20px 0;
`
